import { AiOutlineMenu } from "react-icons/ai";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

export const CustomHeader = styled.header`
  background-color: white;
  box-shadow: 2px 1px 8px rgba(138, 167, 196, 0.5);
  width: 100%;
  position: relative;
  top: 0;
  z-index: 1;
  height: auto;

  @media (max-width: 768px) {
    height: ${(props) => (props.isDropdownActive ? "auto" : "auto")};
    transition: 0.3s ease-in-out;
  }

  @media (min-width: 1536px) {
    height: auto;
  }
`;

export const Navbar = styled.nav`
  margin-left: auto;
  margin-right: auto;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  width: 90%;
  position: relative;

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 50% 50%;
    align-items: center;
    width: 85%;
  }

  @media (min-width: 1024px) {
    width: 80%;
    min-height: 52px;
  }
`;

export const NavLogo = styled(NavLink)`
  @media (max-width: 768px) {
    width: 20%;
  }

  @media (min-width: 768px) {
    width: 25%;
  }

  @media (min-width: 1536px) {
    width: 20%;
  }
`;

export const NavRight = styled.div`
  display: none;

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
    height: 100%;
  }
`;

export const DropdownMenu = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  grid-gap: 3rem;
  width: 100%;
  margin-top: 3rem;
  /* transition: 0.6s ease-in; */

  @media (min-width: 768px) {
    display: ${(props) => !props.isDropdownActive && "none"};
    height: 0;
  }
`;

export const ProfileSquare = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    border-left-width: 2px;
    padding-left: 2rem;
  }
`;

export const ProfileGrid = styled.div`
  display: grid;
  grid-template-columns: 73% 25%;
  width: 100%;
  height: 100%;
  grid-gap: 2%;

  @media (max-width: 768px) {
    grid-template-columns: 57% 41%;
    width: 60%;
  }
`;

export const ProfileText = styled.p`
  font-size: 12px;

  @media (min-width: 768px) {
    font-size: 12px;
  }

  @media (min-width: 1024px) {
    font-size: 13px;
  }
`;

export const MenuIcon = styled(AiOutlineMenu)`
  font-size: 22px;
`;

export const DropDownBtn = styled.button`
  position: absolute;
  right: 0;
  top: 12px;

  @media (min-width: 768px) {
    display: none;
  }

  &:focus {
    outline: none;
  }
`;
